import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { CustomLoadingOverlay } from '../../../../../ui/implementations/core/components/CustomLoadingOverlay';
import { AuthenticationModuleClientType } from '../../../../types';
import { onShowErrorNotification, onShowSuccessNotification } from '../notifications';
export const RedirectPage: AuthenticationModuleClientType['RedirectPage'] = ({ onCallLoginEndpoint, paths }) => {
  const { login, home } = paths;

  const router = useRouter();
  const {
    query: { code: authCode, state: queryState },
    isReady: routerIsReady
  } = router;

  const { redirectTo } = JSON.parse((queryState as string | undefined) ?? '{}');
  const loginUrl = `${login}?redirectTo=${redirectTo}`;

  useEffect(() => {
    const onResponseHandle = async () => {
      if (!routerIsReady) {
        // Router needs a moment to read query params
        return;
      }

      if (!authCode) {
        return router.push(loginUrl).then(onShowErrorNotification);
      }

      try {
        await onCallLoginEndpoint({ oAuthCode: authCode });
      } catch (e) {
        return router.push(loginUrl).then(onShowErrorNotification);
      }

      return router.push(redirectTo ?? home).then(onShowSuccessNotification);
    };

    void onResponseHandle();
  }, [authCode, home, loginUrl, onCallLoginEndpoint, redirectTo, router, routerIsReady]);

  return <CustomLoadingOverlay visible />;
};
